import { Pipe, PipeTransform } from '@angular/core';
import { SecureImage } from '@miq/utils';
import { TemplateField } from '../../models/template.model';
import { ReportFieldFormatterService } from '../../report-field-formatter.service';
import { Observable } from 'rxjs';
import { ReportOptions, ReportRecord, DataObject } from '../../models/report.model';

@Pipe({ name: 'reportFieldFormatter' })
export class ReportFieldFormatterPipe implements PipeTransform {
  constructor(private reportFieldFormatterService: ReportFieldFormatterService) {}

  transform(
    record: ReportRecord | ReportRecord[],
    settings: {
      templateId: number;
      field: TemplateField;
      joinString: boolean;
      onlyUrl?: boolean;
      isPDF?: boolean;
      symbols?: DataObject;
      reportOptions?: ReportOptions;
    }
  ): Observable<string | string[] | SecureImage> {
    return this.reportFieldFormatterService.getAndFormatField(record, settings);
  }
}
